import React, { useEffect, useState } from "react";
import {
    Modal,
    Row,
    Col,
    Card,
    Typography,
    Descriptions,
    Tag,
    Table,
    Button,
    Input,
    Select,
    message,
    DatePicker,
} from "antd";
import {
    UserOutlined,
    PhoneOutlined,
    HomeOutlined,
    UsergroupAddOutlined,
    PlusCircleFilled,
    SearchOutlined,
} from "@ant-design/icons";
import DebounceSelect from "../../../components/DebounceSelect";
import { getListCustomers } from "../../../services/apis";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import { FORMAT_DATE, HeaderTableChildCus, LIST_SEX, STATUS_SERVICES, TYPE_COMMISSION, TYPE_MODAL } from "../../../constants/constants";
import ServiceDetailDrawer from "./ServiceDetailDrawer";
import { filterOption, formatNumber } from "../../../utils/funcHelper";
import dayjs from "../../../utils/dayjsConfig";

const { Title, Text } = Typography;
const RegisterServiceModal = ({ visible, onClose, onSave, employees, services }) => {
    const [consultanter, setConsultanter] = useState();
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState([]);
    const [customerSelected, setCustomerSelected] = useState();
    const [customerName, setCustomerName] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [customerAddress, setCustomerAddress] = useState("");
    const [lstServicesRegistered, setLstServicesRegistered] = useState([]);
    const [typeDrawer, setTypeDrawer] = useState();
    const [itemSelected, setItemSelected] = useState();
    const [randomID, setRandomID] = useState(Math.floor(Math.random() * 1000000));
    const [customerDOB, setCustomerDOB] = useState(null); // Ngày sinh
    const [customerGender, setCustomerGender] = useState(LIST_SEX[1].value); // Giới tính
    const columns = [
        {
            title: "STT",
            render: (src, record, index) => index + 1,
            align: "center",
            width: 50,
        },
        {
            title: "Tên dịch vụ",
            dataIndex: "service_name",
            key: "service_name",
            width: 300,
            render: (text, record) => <a onClick={() => handleShowDetailService(record)}>{text}</a>,
        },
        {
            title: "Loại vé",
            dataIndex: "ticket_type_name",
            key: "ticket_type_name",
            align: "center",
            width: 100,
        },
        {
            title: "Đơn giá",
            dataIndex: "sale_price",
            key: "sale_price",
            align: "center",
            render: (price) => <Text strong>{formatNumber(parseInt(price), 0)}</Text>,
            width: 120,
        },
        {
            title: "Giảm giá",
            dataIndex: "discount",
            key: "discount",
            align: "center",
            render: (discount, record) => <Text style={{paddingLeft: 4, paddingRight: 4}}>{record?.discount_type === TYPE_COMMISSION[0].value ? discount : formatNumber(parseInt(discount), 0)} {record?.discount_type === TYPE_COMMISSION[0].value ? "%" : "vnđ"}</Text>,
            width: 100,
        },

        {
            title: "S.buổi",
            dataIndex: "total_sessions",
            key: "total_sessions",
            align: "center",
            render: (quantity) => <Text strong>{quantity}</Text>,
            width: 60,
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            align: "center",
            width: 120,
            render: (status) => {
                let color = 'default';
                let text = 'N/A';
                if (status === STATUS_SERVICES[0].value) {
                    color = 'blue';
                    text = 'Đang thực hiện';
                } else if (status === STATUS_SERVICES[1].value) {
                    color = 'green';
                    text = 'Đã hoàn thành';
                } else if (status === STATUS_SERVICES[2].value) {
                    color = 'red';
                    text = 'Huỷ dịch vụ';
                }
                return <Tag color={color}>{text}</Tag>;
            }
        },
        {
            title: "Ngày đký",
            dataIndex: "regis_date",
            key: "regis_date",
            width: 120,
        },
        {
            title: "Bắt đầu",
            dataIndex: "start_date",
            key: "start_date",
            width: 120,
        },
        {
            title: "Kết thúc",
            dataIndex: "end_date",
            key: "end_date",
            width: 120,
        },
    ];

    const handleShowDetailService = (record) => {
        setItemSelected(record);
        setTypeDrawer(TYPE_MODAL.EDIT);
        setRandomID(Math.floor(Math.random() * 1000000));
        setOpen(true);
    }

    const findCustomers = async (keyword) => {
        try {
            const params = {
                keyword: keyword,
                limit: 100,
                currentPage: 1,
            };
            const response = await getListCustomers(params); // Gọi API
            const results = response?.data?.data || []; // Lấy dữ liệu từ API
            consoleLogUtil("Fetched customers:", results);
            return results.map((customer) => ({
                label: customer.full_name, // Hiển thị tên khách hàng
                value: customer.id, // Giá trị là ID khách hàng
                customer, // Truyền toàn bộ đối tượng khách hàng nếu cần
            }));
        } catch (error) {
            console.error("Error fetching customers:", error);
            return []; // Trả về mảng rỗng nếu có lỗi
        }
    };

    const onClearCustomer = () => {
        setCustomerSelected(null);
        setValue([]);
        setCustomerName("");
        setCustomerPhone("");
        setCustomerAddress("");
    }



    const handleOpenDrawer = () => {
        setRandomID(Math.floor(Math.random() * 1000000));
        setTypeDrawer(TYPE_MODAL.ADD);
        setOpen(true);
    }



    const calculateTotalAmount = () => {
        const total = lstServicesRegistered.filter(item => item?.status !== STATUS_SERVICES[2].value).reduce((total, item) => {
            return total + (item?.total_amount || 0);
        }, 0);
        return formatNumber(total);
    }

    const handleSaveServicesRegis = (newService) => {
        consoleLogUtil("New service to save:", newService);
        onCloseDrawer();
        if (typeDrawer === TYPE_MODAL.ADD) {
            // Kiểm tra dịch vụ đã được thêm chưa trong lstServicesRegistered
            const isDuplicate = lstServicesRegistered.some(
                (item) =>
                    item.service_id === newService.service_id &&
                    item.ticket_type === newService.ticket_type
            );

            if (isDuplicate) {
                message.error('Dịch vụ đã được thêm. Vui lòng chọn dịch vụ khác.');
                return;
            }

            // Thêm dịch vụ mới vào lstServicesRegistered
            const updatedServices = [...lstServicesRegistered, newService];
            setLstServicesRegistered(updatedServices); // Cập nhật lại danh sách dịch vụ trong state
        }

        if (typeDrawer === TYPE_MODAL.EDIT) {
            const updatedServices = lstServicesRegistered.map((item) =>
                item.id === newService.id ? newService : item
            );
            setLstServicesRegistered(updatedServices); // Cập nhật lại danh sách dịch vụ trong state
        }

    }

    const onCloseDrawer = () => {
        setOpen(false);
    }
    const handleOnSaveModal = () => {
        if (!customerName || !customerPhone) {
            message.error('Vui lòng nhập đầy đủ thông tin khách hàng');
            return;
        }
        if (lstServicesRegistered.length === 0 || lstServicesRegistered.every(item => item.status === '3')) {
            message.error('Vui lòng thêm dịch vụ');
            return;
        }
        if (onSave) {
            const customerData = {
                customer_id: customerSelected?.id || null,
                isNewCustomer: customerSelected?.id ? false : true,
                full_name: customerName,
                phone: customerPhone,
                address: customerAddress,
                lst_services: lstServicesRegistered.filter(item => item?.status !== STATUS_SERVICES[2].value), // Lọc bỏ những dịch vụ có trạng thái "Huỷ dịch vụ"
                consultant_ids: consultanter || null,
                birth_day: customerDOB ? customerDOB.format(FORMAT_DATE.YYYYMMDD) : null,
                gender: customerGender || LIST_SEX[1].value,
            }
            onSave(customerData);
            onClose();
        }
    }

    useEffect(() => {
        setLstServicesRegistered([]);
        setConsultanter();
        setValue([]);
        setCustomerSelected();
        setCustomerName("");
        setCustomerPhone("");
        setCustomerAddress("");
        setCustomerDOB(null);
    }, [visible]);

    return (
        <Modal
            title="Đăng ký dịch vụ mới"
            open={visible}
            onCancel={onClose}
            width={'90%'}
            bodyStyle={{ backgroundColor: "#f5f5f5", padding: 16 }}
            className="custom-modal"
            maskClosable={false}
            keyboard={false}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Đóng
                </Button>,
                <Button
                    key="save"
                    type="primary"
                    onClick={() => handleOnSaveModal()}
                >
                    Đăng ký
                </Button>,
            ]}
        >
            <Row gutter={16}>
                {/* CỘT TRÁI */}
                <Col span={16}>
                    <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                        <Title level={5}>Thông tin chung</Title>
                        <Descriptions
                            column={1}
                            bordered
                            size="middle"
                            labelStyle={{ width: "25%", fontWeight: 500, background: "#fafafa", fontSize: 14, color: 'black', fontFamily: 'Roboto, Arial, sans-serif' }}
                            contentStyle={{ textAlign: "right", padding: "8px 12px" }}
                        >
                            <Descriptions.Item label={<><SearchOutlined /> Tìm kiếm KH cũ</>}>
                                <DebounceSelect
                                    value={value}
                                    placeholder="Tìm kiếm khách hàng"
                                    fetchOptions={findCustomers}
                                    onClear={() => onClearCustomer()}
                                    style={{ width: '60%', height: 40, textAlign: 'left', display: 'block' }}
                                    onChange={(newValue, option) => {
                                        consoleLogUtil("Selected value:", newValue);
                                        consoleLogUtil("Selected option:", option);
                                        setValue(newValue);

                                        // option có thể là mảng (nhiều lựa chọn) hoặc object (một lựa chọn)
                                        const customer = option?.customer;

                                        if (customer) {
                                            setCustomerSelected(customer);
                                            setCustomerName(customer.full_name ?? "");
                                            setCustomerPhone(customer.phone ?? '');
                                            setCustomerAddress(customer.address ?? "");
                                            setCustomerDOB(customer.birth_day ? dayjs(customer.birthday, FORMAT_DATE.YYYYMMDD) : null);
                                            setCustomerGender(customer?.gender ?? LIST_SEX[1].value);
                                        }
                                    }}
                                />
                            </Descriptions.Item>
                            <Descriptions.Item label={<><UserOutlined /> Họ và tên *</>}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Input
                                        placeholder="Nhập họ và tên"
                                        style={{ width: '60%', textAlign: 'left' }}
                                        disabled={customerSelected ? true : false}
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 16, width: '40%', alignItems: 'center' }}>
                                        <Text style={{ marginRight: 8, width: 120 }}>Giới tính(*):</Text>
                                        <Select
                                            placeholder="Chọn giới tính"
                                            allowClear
                                            value={customerGender}
                                            onChange={setCustomerGender}
                                            style={{ width: '100%', textAlign: 'left', height: 40 }}
                                            options={LIST_SEX}
                                            disabled={customerSelected ? true : false}
                                        />

                                    </div>
                                </div>

                            </Descriptions.Item>
                            <Descriptions.Item label={<><PhoneOutlined /> Số điện thoại *</>}>

                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Input
                                        placeholder="Nhập số điện thoại"
                                        style={{ width: '60%', textAlign: 'left' }}
                                        disabled={customerSelected ? true : false}
                                        value={customerPhone}
                                        onChange={(e) => setCustomerPhone(e.target.value)}
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 16, width: '40%', alignItems: 'center' }}>
                                        <Text style={{ marginRight: 8, width: 120 }}>Ngày sinh:</Text>
                                        <DatePicker
                                            format={"DD/MM/YYYY"}
                                            placeholder="Chọn ngày sinh"
                                            style={{ width: '100%', textAlign: 'left', height: 40 }}
                                            value={customerDOB}
                                            onChange={(date, dateString) => setCustomerDOB(date)}
                                            disabled={customerSelected ? true : false}
                                        />

                                    </div>
                                </div>
                            </Descriptions.Item>
                            <Descriptions.Item label={<><HomeOutlined /> Địa chỉ</>}>
                                <Input
                                    placeholder="Nhập địa chỉ"
                                    style={{ width: '100%', textAlign: 'left' }}
                                    disabled={customerSelected ? true : false}
                                    value={customerAddress}
                                    onChange={(e) => setCustomerAddress(e.target.value)}
                                />
                            </Descriptions.Item>
                            <Descriptions.Item label={<><UsergroupAddOutlined /> Người tư vấn</>}>
                                <Select
                                    placeholder="Chọn người tư vấn"
                                    allowClear
                                    mode="multiple"
                                    maxTagCount='responsive'
                                    value={consultanter}
                                    onChange={setConsultanter}
                                    style={{ width: '50%', textAlign: 'left', height: 40, display: 'block' }}
                                    showSearch
                                    filterOption={filterOption}
                                    options={employees}
                                />
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>

                    {/* Items */}
                    <Card size="small" style={{ borderRadius: 8 }}>
                        <Button
                            icon={<PlusCircleFilled />}
                            style={{ height: 36, marginBottom: 16, borderRadius: 8, backgroundColor: '#52c41a', color: 'white', border: 'none' }}
                            onClick={() => handleOpenDrawer()}
                        >
                            Thêm dịch vụ
                        </Button>
                        <Table
                            components={HeaderTableChildCus}
                            columns={columns}
                            dataSource={lstServicesRegistered}
                            pagination={false}
                            rowKey={(record) => record.id}
                            scroll={{ x: 900 }}
                        />
                    </Card>
                </Col>

                {/* CỘT PHẢI */}
                <Col span={8}>
                    <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                        <Title level={5}>Thông tin thanh toán</Title>
                        {
                            lstServicesRegistered?.length > 0 ?
                                lstServicesRegistered.map((item, index) => {
                                    if (item.status === '3') return null; // Bỏ qua dịch vụ có trạng thái "Huỷ dịch vụ"
                                    return (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                            <span>{index + 1}. {item?.service_name ?? ''}</span>
                                            <Text strong style={{ textAlign: 'right', width:150 }}>{formatNumber(item?.total_amount)}</Text>
                                        </div>
                                    )
                                })
                                : null
                        }

                        <div style={{ borderTop: '1px solid #d9d9d9', margin: '12px 0' }}></div> {/* Đường gạch ngang */}
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Title level={5} style={{ margin: 0 }}>Thành tiền (vnđ):</Title>
                            <Title level={5} style={{ margin: 0, textAlign: 'right' }}>{calculateTotalAmount()}</Title>
                        </div>
                    </Card>
                </Col>
            </Row>
            <ServiceDetailDrawer
                isOpen={open}
                onClose={onCloseDrawer}
                onSave={handleSaveServicesRegis}
                services={services}
                type={typeDrawer}
                randomID={randomID}
                data={itemSelected}
            />
        </Modal>
    );
};

export default RegisterServiceModal;
